import React from 'react'
import PropTypes from 'prop-types'
import { graphql, Link } from 'gatsby'
import Img from 'gatsby-image'
import get from 'lodash/get'
import { truncate, getBaseUrl } from '../utils/utils'
import { styledBox } from '../utils/constants'
import Layout from '../components/Layout'
import SeoHead from '../components/SeoHead'
import Shoe from '../components/Shoe'
import BlogPostList from '../components/BlogPostList'

const SingleShoeTemplate = ({ data, pageContext }) => {
  const siteTitle = get(data, 'site.siteMetadata.title')
  const shoe = get(data, 'allContentfulShoe.nodes.[0]')
  const content = get(shoe, 'shoe_paragraph.[0].content')
  const blogPosts = get(data, 'allContentfulBlogPost.nodes')
  const { slug, originalPath, id, title } = pageContext
  const description = truncate(get(content, 'content') || '')

  return (
    <Layout>
      <SeoHead
        title={`${siteTitle} | ${shoe.title}`}
        ogDescription={description}
        ogImageUrl={`http:${shoe.thumbnail.fluid.src}`}
        ogUrl={`${getBaseUrl()}${originalPath}}`}
      />
      <main style={styledBox}>
        <Shoe shoe={shoe} content={content} />
        <BlogPostList blogPosts={blogPosts} shoeSlug={shoe.slug} />
      </main>
    </Layout>
  )
}

SingleShoeTemplate.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.shape({
    title: PropTypes.string,
    slug: PropTypes.string,
    originalPath: PropTypes.string,
    routed: PropTypes.bool,
  }),
}

export default SingleShoeTemplate

export const pageQuery = graphql`
  query singleShoeQuery($id: String!, $title: String!) {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulShoe(
      filter: { id: { eq: $id } }
      sort: { fields: updatedAt, order: DESC }
      limit: 1
    ) {
      totalCount
      nodes {
        id
        title
        shoeName
        slug
        updatedAt
        thumbnail {
          id
          fluid(maxWidth: 480, resizingBehavior: SCALE) {
            src
            srcSet
            sizes
            srcWebp
            # tracedSVG
            aspectRatio
          }
        }
        shoe_paragraph {
          content {
            childMarkdownRemark {
              html
            }
            content
          }
          blog_post {
            id
            title
          }
        }
      }
    }

    allContentfulBlogPost(
      filter: { shoes: { elemMatch: { shoe: { title: { eq: $title } } } } }
    ) {
      totalCount
      nodes {
        slug
        title
        legacyTitle
        createdAt
        updatedAt
        legacy
        category
      }
    }
  }
`
